import { Link, useNavigate } from "react-router-dom";

export default function FuelExpenseTable() {
  const navigate = useNavigate();

  const handleNavigate = (vehiclenumber) => {
    navigate(`/${vehiclenumber}`);
  };

  const data = [
    { id: 1, vehiclenumber: "MH20ER4534", currentodometer: "45000", quantity: "4", amount: "$25335", date: "Mon May 12 2025" },
    { id: 2, vehiclenumber: "MH02MN0098", currentodometer: "45000", quantity: "4", amount: "$25335", date: "Mon May 12 2025" },
    { id: 3, vehiclenumber: "MH03AS3945", currentodometer: "45000", quantity: "24", amount: "$25335", date: "Mon May 12 2025" },
    { id: 4, vehiclenumber: "MH04KL0921", currentodometer: "45000", quantity: "45", amount: "$25335", date: "Mon May 12 2025" },
    { id: 5, vehiclenumber: "MH05MH5932", currentodometer: "45000", quantity: "44", amount: "$25300", date: "Mon May 12 2025" },
    { id: 6, vehiclenumber: "MH06MJ4321", currentodometer: "45000", quantity: "4", amount: "$25200", date: "Mon May 12 2025" },
    { id: 7, vehiclenumber: "MH07ND4567", currentodometer: "45000", quantity: "5", amount: "$25533", date: "Mon May 12 2025" },
    { id: 8, vehiclenumber: "MH08KK4909", currentodometer: "45000", quantity: "3", amount: "$24000", date: "Mon May 12 2025" },
    { id: 9, vehiclenumber: "MH11KL0008", currentodometer: "45000", quantity: "11", amount: "23000", date: "Mon May 12 2025" },
    { id: 10, vehiclenumber: "MH20UI3424", currentodometer: "45000", quantity: "12", amount: "25000", date: "Mon May 12 2025" },
    { id: 11, vehiclenumber: "MH20SQ9021", currentodometer: "55000", quantity: "34", amount: "26000", date: "Mon May 12 2025" },
    { id: 12, vehiclenumber: "MH23MK8245", currentodometer: "55000", quantity: "13", amount: "26543", date: "Mon May 12 2025" },
    { id: 13, vehiclenumber: "MH24NF5321", currentodometer: "55000", quantity: "55", amount: "$22422", date: "Mon May 12 2025" },
    { id: 14, vehiclenumber: "MH22PQ4441", currentodometer: "55000", quantity: "12", amount: "$25335", date: "Mon May 12 2025" },
    { id: 15, vehiclenumber: "MH12EE2323", currentodometer: "55000", quantity: "34", amount: "$25300", date: "Mon May 12 2025" },
    { id: 16, vehiclenumber: "MH11FG9090", currentodometer: "55000", quantity: "6", amount: "$25335", date: "Mon May 12 2025" },
    { id: 17, vehiclenumber: "MH20UI1221", currentodometer: "35000", quantity: "9", amount: "$25335", date: "Mon May 12 2025" },
    { id: 18, vehiclenumber: "MH20EE0890", currentodometer: "35000", quantity: "22", amount: "$25335", date: "Mon May 12 2025" },
    { id: 19, vehiclenumber: "MH20SQ0987", currentodometer: "45000", quantity: "21", amount: "$22000", date: "Mon May 12 2025" },
    { id: 20, vehiclenumber: "MH21XQ0087", currentodometer: "45000", quantity: "21", amount: "$22000", date: "Mon May 12 2025" },
  ];

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Fuels</h4>
        <div className="yc-header-actions">
          <Link to="/createvehiclefuel" className="btn btn-primary">
            Create Vehicle Fuel
          </Link>
          <div className="dropdown">
            <button
              id="btnGroupDropExport"
              type="button"
              className="btn btn-primary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Export
            </button>
            <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
              <li><a className="dropdown-item" href="#">Save as PDF</a></li>
              <li><a className="dropdown-item" href="#">Save as CSV</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select className="form-select">
            <option>Vehicle No</option>
            <option>MH20EE3948</option>
            <option>MH21RE4890</option>
          </select>
          <input type="text" className="form-control" placeholder="Enter Odometer Riding" />
          <button type="button" className="btn btn-primary">Clear</button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-7">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Vehicle Number</div>
            <div className="yc-list-cell">Current Odometer</div>
            <div className="yc-list-cell">Quantity</div>
            <div className="yc-list-cell">Amount</div>
            <div className="yc-list-cell">Date</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        <div className="yc-list-row-list">
          {data.map((row, idx) => (
            <div key={row.id} className="yc-list-row-card">
              <div className="yc-list-grid yc-list-grid-7">
                <div className="yc-list-cell">{idx + 1}</div>
                <div className="yc-list-cell">{row.vehiclenumber}</div>
                <div className="yc-list-cell">{row.currentodometer}</div>
                <div className="yc-list-cell">{row.quantity}</div>
                <div className="yc-list-cell">{row.amount}</div>
                <div className="yc-list-cell">{row.date}</div>
                <div className="yc-list-cell yc-list-cell--actions">
                  <button
                    type="button"
                    className="yc-action-icon"
                    onClick={() => handleNavigate(row.vehiclenumber)}
                    title="View"
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                  <Link to="/updatevehiclefuel" className="yc-action-icon" title="Edit">
                    <i className="bi bi-pencil-square"></i>
                  </Link>
                  <button
                    type="button"
                    className="yc-action-icon yc-action-icon--danger"
                    title="Delete"
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
